<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Add Award Points</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link :to="{ name: 'award-points' }">Award Points</router-link>
      /
      <b>Add New</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <!-- Tabs -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <!-- Individual -->
              <li class="nav-item">
                <a
                  class="nav-link active show"
                  @click=changeType(1)
                  id="individual-tab"
                  data-toggle="tab"
                  href="#individual"
                  role="tab"
                  aria-controls="individual"
                  aria-selected="true"
                  >Individual</a
                >
              </li>

              <!-- Multiple -->
              <li class="nav-item">
                <a
                  class="nav-link"
                  @click=changeType(2)
                  id="multiple-tab"
                  data-toggle="tab"
                  href="#multiple"
                  role="tab"
                  aria-controls="multiple"
                  aria-selected="false"
                  >Multiple</a
                >
              </li>
            </ul>
            <!-- End Tabs -->

            <!-- Points info -->
            <div v-show="type == 'multiple'" class="row mt-4">
              <div class="col-4">
                <label>Event Name</label>
                <div class="input-group d-flex flex-row p2">
                  <input
                    type="text"
                    class="form-control mr-2"
                    v-model="event_name"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-4">
                <label>Points Awarded</label>
                <div class="input-group d-flex flex-row p2">
                  <input
                    type="number"
                    class="form-control mr-2"
                    v-model="point"
                  />
                </div>
              </div>

              <div class="col-6">
                <label>Description</label>
                <div class="input-group d-flex flex-row p2">
                  <textarea
                    type="input"
                    class="form-control mr-2"
                    v-model="description"
                  >
                  </textarea>
                </div>
              </div>

              <div class="col-2">
                <button
                  class="btn btn-primary btn-wide mt-4"
                  @click="storeAward()"
                >
                  Submit
                </button>
              </div>
            </div>
            <!-- End Points info -->

            <hr />

            <!-- Tab Contents -->
            <div class="tab-content" id="myTabContent">
              <!-- Individual content -->
              <div
                class="tab-pane fade active show bg-white"
                id="individual"
                role="tabpanel"
                aria-labelledby="individual-tab"
              >
                <div class="row">
                  <div class="col-3">
                    <label>Search</label>
                    <div class="input-group d-flex flex-row p2">
                      <input
                        type="input"
                        class="form-control mr-2"
                        v-model="ic_number"
                      />
                      <button
                        type="button"
                        class="btn btn-primary mr-1"
                        @click="getUserAccountNumber"
                      >
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 mt-3" style="font-size: 1.3em">
                    <label style="font-weight: bold">My Takaful ID: </label>
                    <label class="ml-2" style="font-weight: bold">{{
                      data.account_number
                    }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label>Name: </label>
                    <label class="ml-2">{{ data.name }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label>Email: </label>
                    <label class="ml-2">{{ data.email }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label>Mobile No: </label>
                    <label class="ml-2">{{ data.phone_number }}</label>
                  </div>
                </div>
              </div>

              <!-- Multiple content -->
              <div
                class="tab-pane fade bg-white"
                id="multiple"
                role="tabpanel"
                aria-labelledby="multiple-tab"
              >
                <input
                  type="file"
                  id="excel_upload"
                  ref="file"
                  @change="excelUpload"
                  class="inputfile"
                />
                <hr />

                <div class="table-responsive">
                  <h3 class="ml-1">
                    <b>Selected Users</b>
                  </h3>
                  <table
                    id="uploaded_users"
                    class="display table table-striped table-bordered"
                  >
                    <thead>
                      <tr>
                        <th>My Takaful ID</th>
                        <th>IC Number</th>
                        <th>Name</th>
                        <th>Mobile Number</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- End of tab contents -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import "vue-select/dist/vue-select.css";
import { postRequest } from "@/services/RequestService";
import readXlsxFile from "read-excel-file";
import xlsx from "xlsx";

export default {
  name: "add-award-points",
  mixins: [dateManipulation],
  components: {},

  data() {
    return {
      data: {
        account_number: "000000",
        name: "",
        email: "",
        phone_number: "",
      },

      type: "",
      user_id: null,
      ic_number: null,
      point: 0,
      description: "",
      fileUploaded: null,
      event_name: null
    };
  },

  methods: {
    async getUserAccountNumber() {
      try {
        let res = await postRequest(axios.lpsURL + `/award/check_user`, {
          ic_number: this.ic_number,
        });
        this.data = res.data.success
          ? res.data.data
          : {
              account_number: "Not Found",
              name: "Not Found",
              email: "Not Found",
              phone_number: "Not Found",
            };
        this.user_id = res.data.success ? res.data.data.user_id : null;
      } catch (e) {
        console.log(e);
      }
    },

    async storeAward() {
      this.type = "individual";

      // Validations
      if ($("#multiple").hasClass("active")) {
        this.user_id = 1; // Default value as this will not be used
        this.type = "multiple";

        if (document.getElementById("excel_upload").files.length == 0) {
          swal({
            title: "Failed",
            icon: "error",
            text: "Please upload a file before submitting",
          });

          return;
        }

        if(this.event_name == null || this.event_name == '') {
          swal({
            title: "Failed",
            icon: "error",
            text: "Please enter event name.",
          });

          return;
        }
      }

      let formData = new FormData();
      formData.append("user_id", this.user_id);
      formData.append("description", this.description);
      formData.append("point", this.point);
      formData.append("type", this.type);
      formData.append("fileUploaded", this.fileUploaded);
      formData.append("event_name", this.event_name);

      try {
        let res = await postRequest(`/loyalty/award`, formData);
        swal({
          title: res.data.success ? "Success" : "Failed",
          icon: res.data.success ? "success" : "error",
          text: res.data.message,
        });

        if (res.data.success) {
          this.reset();
          this.$router.push("award-points");
        }
      } catch (e) {
        console.log(e);
      }
    },

    reset() {
      this.user_id = null;
      this.account_number = "000000";
    },

    excelUpload(e) {
      this.fileUploaded = this.$refs.file.files[0];
      const input = document.getElementById("excel_upload");
      let table = $("#uploaded_users").find("tbody");

      // Clear table
      $("#uploaded_users tbody tr").remove();

      readXlsxFile(input.files[0]).then((rows) => {
        let data;
        rows.shift();
        rows.forEach((array, key1) => {
          data = "<tr>";

          array.forEach((element, key) => {
            data += "<td>" + element + "</td>";
          });

          data += "</tr>";

          table.append(data);
        });

        this.loadTable();
      });
    },

    loadTable() {
      $("#uploaded_users").DataTable({
        dom: "frtip",
        pageLength: 20,
      });
    },

    changeType(type) {
      type == 1 ? this.type = 'individual' : this.type = 'multiple'
    },

    lps() {
      return this.$lps();
    },
  },
};
</script>

<style scoped>
input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  background-color: #AC8400;
  border-color: #AC8400;

  /* cursor: pointer; */
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  color: #fff;
    background-color: #806200;
    border-color: #b38900;
}
</style>
